import { render, staticRenderFns } from "./allpaymentoptions.vue?vue&type=template&id=1297f50a"
import script from "./allpaymentoptions.vue?vue&type=script&lang=js"
export * from "./allpaymentoptions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports